module.exports = __webpack_public_path__ + "static/media/answer_hyper@2x.6865aa09.png";